/**
 * Custom theme script: keep collection/search at top on load.
 * - Removes #ResultsList hash and scrolls to top immediately.
 * - Re-applies scroll to top after DOMContentLoaded and load (undoes scrollIntoView from other scripts e.g. color-variant-cards).
 * - Uses delayed timeouts so we run after other DOMContentLoaded handlers that might scroll the page.
 */
(function () {
  const path = window.location.pathname;
  const isCollectionOrSearch =
    path.includes('/collections/') ||
    path === '/search' ||
    path.startsWith('/search?');
  if (!isCollectionOrSearch) return;

  function isBackForward() {
    const nav =
      performance.getEntriesByType &&
      performance.getEntriesByType('navigation')[0];
    return nav && nav.type === 'back_forward';
  }

  const hashId = window.location.hash ? window.location.hash.slice(1) : '';
  if (hashId === 'ResultsList') {
    history.replaceState(null, '', window.location.pathname + window.location.search);
  }

  if (isBackForward()) return;

  window.scrollTo(0, 0);

  function forceTop() {
    if (isBackForward()) return;
    window.scrollTo(0, 0);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      forceTop();
      setTimeout(forceTop, 0);
      setTimeout(forceTop, 100);
    });
  } else {
    forceTop();
    setTimeout(forceTop, 0);
    setTimeout(forceTop, 100);
  }

  window.addEventListener('load', function () {
    forceTop();
    setTimeout(forceTop, 50);
  });
})();